/* ==========================================================================
   ANGELUS PRESS -- Tabbed Mega Menu interactivity

   Wires up the [data-mega-menu-tabbed] containers:
     - Click / Enter / Space on a tab activates its panel
     - Hover on a tab activates its panel (desktop)
     - ArrowUp / ArrowDown / Home / End cycle through tabs (vertical rail)
     - ArrowLeft / ArrowRight also work for horizontal (mobile) layout
     - aria-selected, aria-controls, hidden, tabindex kept in sync
   ========================================================================== */
(function () {
  'use strict';

  var HOVER_DELAY_MS = 70;

  function activateTab(root, tabBtn) {
    if (!tabBtn || tabBtn.classList.contains('is-active')) return;

    var tabs = root.querySelectorAll('[data-mega-tab]');
    var panels = root.querySelectorAll('[data-mega-panel]');
    var targetId = tabBtn.getAttribute('data-target');

    Array.prototype.forEach.call(tabs, function (t) {
      var isActive = t === tabBtn;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    Array.prototype.forEach.call(panels, function (p) {
      var isActive = p.id === targetId;
      p.classList.toggle('is-active', isActive);
      if (isActive) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });
  }

  function focusTab(tab) {
    if (tab) tab.focus();
  }

  function handleKeydown(root, tabs, event) {
    var key = event.key;
    var currentIndex = Array.prototype.indexOf.call(tabs, event.target);
    if (currentIndex < 0) return;

    var lastIndex = tabs.length - 1;
    var nextIndex = null;

    switch (key) {
      case 'ArrowDown':
      case 'ArrowRight':
        nextIndex = currentIndex === lastIndex ? 0 : currentIndex + 1;
        break;
      case 'ArrowUp':
      case 'ArrowLeft':
        nextIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = lastIndex;
        break;
      case 'Enter':
      case ' ':
      case 'Spacebar':
        event.preventDefault();
        activateTab(root, event.target);
        return;
      default:
        return;
    }

    if (nextIndex !== null) {
      event.preventDefault();
      var nextTab = tabs[nextIndex];
      activateTab(root, nextTab);
      focusTab(nextTab);
    }
  }

  function init(root) {
    if (!root || root.dataset.megaMenuTabbedInit === '1') return;
    root.dataset.megaMenuTabbedInit = '1';

    var tabs = root.querySelectorAll('[data-mega-tab]');
    if (!tabs.length) return;

    var hoverTimer = null;

    Array.prototype.forEach.call(tabs, function (tab) {
      tab.addEventListener('click', function () {
        activateTab(root, tab);
      });

      tab.addEventListener('focus', function () {
        activateTab(root, tab);
      });

      // Hover-activated panel preview on devices that support hover
      tab.addEventListener('mouseenter', function () {
        if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () {
          activateTab(root, tab);
        }, HOVER_DELAY_MS);
      });

      tab.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.target && event.target.matches && event.target.matches('[data-mega-tab]')) {
        handleKeydown(root, tabs, event);
      }
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-mega-menu-tabbed]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after Shopify section reload (theme editor) or dynamic injection
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
})();
